import type {
  CostEntry,
  LedgerEntry,
  PackageRecord,
  TrainerException,
  TrainerSchedule
} from "./types";

export const customerTypes = [
  "Pilates",
  "Skolyoz",
  "Manuel",
  "Görüşme",
  "Değerlendirme",
  "Diğer",
  "TJM"
];

export const districts = [
  "Kadıköy",
  "Üsküdar",
  "Ataşehir",
  "Ümraniye",
  "Beykoz",
  "Maltepe",
  "Çekmeköy",
  "Diğer"
];

export const trainers = ["Cansu Kara", "Cansu Kütük", "Sima Nur"];

export const salesPeople = ["Cansu Kara", "Cansu Kütük", "Sima Nur"];

export const sessionTypes = [
  "Bireysel Pilates",
  "Grup Pilates",
  "Duo Pilates",
  "Hamile Pilates",
  "Skolyo-Pilates",
  "Manuel",
  "Schroth",
  "Diğer"
];

export const priceRows = [
  { service: "Bireysel Pilates", eight: 12000, sixteen: 22000 },
  { service: "Duo Pilates", eight: 10000, sixteen: 18000 },
  { service: "Grup Pilates", eight: 8000, sixteen: 14000 },
  { service: "Skolyo Pilates", eight: 12500, sixteen: 23000 },
  { service: "Hamile Pilates", eight: 12500, sixteen: 23000 }
];

export const manualPriceRows = [
  { service: "Schroth", one: 3750, five: 16000, ten: 28000 },
  { service: "Manuel", one: 3750, five: 16000, ten: 28000 }
];

export const packageRecordsSeed: PackageRecord[] = [
  { id: "REC-9503", customerId: "CUS-00148", customer: "Ayşe Kaya", detail: "Schroth-5", quantity: 5, price: 16000, registrationDate: "2026-05-01" },
  { id: "REC-9502", customerId: "CUS-00148", customer: "Ayşe Kaya", detail: "Pilates-12", quantity: 12, price: 7200, registrationDate: "2026-07-01" },
  { id: "REC-9501", customerId: "CUS-00207", customer: "Selin Arslan", detail: "Skolyo Pilates-8", quantity: 8, price: 6400, registrationDate: "2026-06-28" },
  { id: "REC-9500", customerId: "CUS-00232", customer: "Ece Yıldız", detail: "Pilates-12", quantity: 12, price: 7200, registrationDate: "2026-06-25" },
  { id: "REC-9498", customerId: "CUS-00092", customer: "Zeynep Aydın", detail: "Hamile Pilates-8", quantity: 8, price: 6400, registrationDate: "2026-07-10", cancellationsUsed: 2 },
  { id: "REC-9497", customerId: "CUS-00318", customer: "Deniz Koç", detail: "Pilates-4", quantity: 4, price: 2600, registrationDate: "2026-07-05" },
  { id: "REC-9496", customerId: "CUS-00254", customer: "Ceren Aksoy", detail: "Pilates-8", quantity: 8, price: 5600, registrationDate: "2026-07-05" },
  { id: "REC-9499", customerId: "CUS-00176", customer: "Melis Şahin", detail: "Grup Pilates-16", quantity: 16, price: 8800, registrationDate: "2026-06-18" }
];

export const ledgerSeed: LedgerEntry[] = [
  { id: "LED-12060", description: "Record", customerId: "CUS-00148", customer: "Ayşe Kaya", quantity: 5, remainingQuantity: 5, price: 16000, remainingAmount: 16000, relatedWith: "Schroth-5", date: "2026-05-01", reference: "R9503" },
  { id: "LED-12061", description: "Record", customerId: "CUS-00148", customer: "Ayşe Kaya", quantity: 12, remainingQuantity: 7, price: 7200, remainingAmount: 0, relatedWith: "Pilates-12", date: "2026-07-01", reference: "R9502" },
  { id: "LED-12062", description: "Payment", customerId: "CUS-00148", customer: "Ayşe Kaya", paymentAmount: 7200, remainingAmount: 0, relatedWith: "Pilates-12", date: "2026-07-01", reference: "P6841" },
  { id: "LED-12063", description: "Session", customerId: "CUS-00148", customer: "Ayşe Kaya", quantity: -1, remainingQuantity: 7, relatedWith: "Pilates-12", date: "2026-07-23", reference: "A10482" },
  { id: "LED-12064", description: "Record", customerId: "CUS-00318", customer: "Deniz Koç", quantity: 4, remainingQuantity: 1, price: 2600, remainingAmount: 0, relatedWith: "Pilates-4", date: "2026-07-05", reference: "R9497" },
  { id: "LED-12065", description: "Record", customerId: "CUS-00207", customer: "Selin Arslan", quantity: 8, remainingQuantity: 3, price: 6400, remainingAmount: 1400, relatedWith: "Skolyo Pilates-8", date: "2026-06-28", reference: "R9501" },
  { id: "LED-12066", description: "Record", customerId: "CUS-00092", customer: "Zeynep Aydın", quantity: 8, remainingQuantity: 5, price: 6400, remainingAmount: 0, relatedWith: "Hamile Pilates-8", date: "2026-07-10", reference: "R9498" },
  { id: "LED-12067", description: "Record", customerId: "CUS-00254", customer: "Ceren Aksoy", quantity: 8, remainingQuantity: 6, price: 5600, remainingAmount: 0, relatedWith: "Pilates-8", date: "2026-07-05", reference: "R9496" },
  { id: "LED-12068", description: "Record", customerId: "CUS-00232", customer: "Ece Yıldız", quantity: 12, remainingQuantity: 9, price: 7200, remainingAmount: 0, relatedWith: "Pilates-12", date: "2026-06-25", reference: "R9500" },
  { id: "LED-12069", description: "Record", customerId: "CUS-00176", customer: "Melis Şahin", quantity: 16, remainingQuantity: 12, price: 8800, remainingAmount: 0, relatedWith: "Grup Pilates-16", date: "2026-06-18", reference: "R9499" }
];

export const costSeed: CostEntry[] = [
  { id: "CST-301", product: "Kira", amount: 38000, date: "2026-07-01" },
  { id: "CST-302", product: "Google Reklam", amount: 6500, date: "2026-07-08" },
  { id: "CST-303", product: "Market", amount: 1840, date: "2026-07-18" },
  { id: "CST-304", product: "Muhasebe", amount: 4200, date: "2026-07-20" }
];

export const costCategories = [
  "Maaş", "Kira", "Stopaj", "KDV", "Muhasebe", "Aidat", "Sigorta",
  "Google Reklam", "Instagram Reklam", "Market", "Yemek", "Diğer"
];

export const trainerSchedulesSeed: TrainerSchedule[] = [
  { id: "SCH-1", trainer: "Cansu Kara", day: "Pazartesi", startTime: "08:00", endTime: "18:00", active: true },
  { id: "SCH-2", trainer: "Cansu Kara", day: "Çarşamba", startTime: "08:00", endTime: "18:00", active: true },
  { id: "SCH-3", trainer: "Cansu Kütük", day: "Salı", startTime: "09:00", endTime: "20:00", active: true },
  { id: "SCH-4", trainer: "Cansu Kütük", day: "Perşembe", startTime: "09:00", endTime: "20:00", active: true },
  { id: "SCH-5", trainer: "Sima Nur", day: "Cuma", startTime: "10:00", endTime: "21:00", active: true }
];

export const trainerExceptionsSeed: TrainerException[] = [
  { id: "EXC-1", trainer: "Cansu Kara", date: "2026-07-27", startTime: "08:00", endTime: "13:00", note: "İzinli" },
  { id: "EXC-2", trainer: "Sima Nur", date: "2026-07-30", startTime: "15:00", endTime: "21:00", note: "Eğitim" }
];

export const messageTemplates = {
  Bayram: "Bayramınızı en içten dileklerimizle kutlarız. The Heal Hub'ta görüşmek üzere.",
  Kapalı: "1 Mayıs günü kapalı olduğumuzu hatırlatmak isteriz!",
  Hatırlatma: "2 kere devamsızlık hakkınız var, unutmayınız lütfen.",
  Kampanya: "Kasım ayına özel 1.000 TL indirim, kaçırmayın."
};
